"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewStepDefinitions = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const misc_1 = require("../../misc");
const implementation_rules_review_types_1 = require("./implementation-rules-review.types");
exports.ReviewStepDefinitions = {
    ReviewParameters: {
        type: 'ReviewParameters',
        displayName: 'Review parameters',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            sigmaModelType: z.string(),
            parameters: misc_1.pkgParametersSchema,
            sequenceGate: misc_1.sequenceGateSchema,
        }),
        outputSchema: z.object({
            parameters: misc_1.pkgParametersSchema,
        }),
    },
    ReviewPinout: {
        type: 'ReviewPinout',
        displayName: 'Review pinout',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
            pinout: misc_1.pkgPinoutSchema,
        }),
        outputSchema: z.object({
            pinout: misc_1.pkgPinoutSchema,
        }),
    },
    ReviewSignals: {
        type: 'ReviewSignals',
        displayName: 'Review signals',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            sigmaModelType: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
        }),
        outputSchema: z.object({
            signals: sigma_engine_shared_1.SignalSchema.array(),
        }),
    },
    ReviewImplementationRules: {
        type: 'ReviewImplementationRules',
        displayName: 'Review implementation rules',
        inputSchema: implementation_rules_review_types_1.ImplementationRulesReviewInputSchema,
        outputSchema: implementation_rules_review_types_1.ImplementationRulesReviewOutputSchema,
    },
};
//# sourceMappingURL=review-steps.js.map